.pes-recommendations {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media screen and (min-width: 980px) {
  .pes-recommendations {
    width: 100%;
    margin: 0 auto;
    padding-top: 36px;
    max-width: 1200px;
  }
}

.pes-recommendations .range-tab {
  display: flex;
}

.pes-recommendations__carousel {
  display: flex;
  gap: 10px;
}